
import { Validator } from "../validator"

enum CardNameError {
    PATTERN = `errors.special_chars`,
    MAX = `errors.card_max`,
    EMPTY = `errors.required`,
}

const MAX = 26
const PATTERN = /^([\u00c0-\u01ffa-zA-Z//',.-\s]+)$/
const NBSP = /%E2%80%86/g

class CardNameValidator implements Validator<string, CardNameError> {
    validate(value: string): CardNameError | undefined {
        const cleanedName = (value ?? ``)
            .replace(/[^A-Za-z ]/g, ``)
            .replace(/\s+/g, ` `)
            .trim()
            .substring(0, MAX)
        if (cleanedName === ``) {
            return CardNameError.EMPTY
        }

        if (cleanedName.length > MAX) {
            return CardNameError.MAX
        }

        if (cleanedName && NBSP.test(encodeURIComponent(cleanedName))) {
            return CardNameError.PATTERN
        }

        if (cleanedName && !PATTERN.test(cleanedName)) {
            return CardNameError.PATTERN
        }
    }
}

export default CardNameValidator
export { CardNameError, MAX, PATTERN }
